// extracted by mini-css-extract-plugin
export default {"container":"GeoStatus_container__TxJaa","url":"GeoStatus_url__daRKa","link":"GeoStatus_link__fUUSx","monitoring":"GeoStatus_monitoring__Bb9Q8"};